(() => {
  if (window.zqDeliveryEstimateLoaded) return;
  window.zqDeliveryEstimateLoaded = true;
  function deliveryWindow(now, minDays, maxDays, zone) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {timeZone: zone, year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).filter(p=>p.type!=='literal').map(p=>[p.type,p.value]));
    const base = new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day),12));
    const start = new Date(base); start.setUTCDate(start.getUTCDate()+minDays);
    const end = new Date(base); end.setUTCDate(end.getUTCDate()+maxDays);
    const options={timeZone:'UTC',month:'short',day:'numeric'};
    if(start.getUTCFullYear()!==end.getUTCFullYear() || end.getUTCFullYear()!==base.getUTCFullYear()) options.year='numeric';
    const format=new Intl.DateTimeFormat('en-US',options);
    return format.format(start)+' – '+format.format(end);
  }
  function refresh() {
    const now=new Date();
    document.querySelectorAll('[data-zq-delivery-range]').forEach(target=>{
      const minDays=Number(target.dataset.zqDeliveryMin);
      const maxDays=Number(target.dataset.zqDeliveryMax);
      const zone=target.dataset.zqDeliveryZone;
      if(!Number.isInteger(minDays) || !Number.isInteger(maxDays) || minDays<0 || maxDays<minDays || !zone)return;
      const range=deliveryWindow(now,minDays,maxDays,zone);
      if(target.textContent!==range)target.textContent=range;
    });
    document.querySelectorAll('[data-zq-delivery]').forEach(card=>{
      const form=card.closest('form');
      const submit=form?.querySelector('button[type="submit"]:not([name="update"]):not([name="checkout"])');
      if(submit)card.hidden=submit.disabled;
    });
  }
  let pending=false;
  function schedule() {
    if(pending)return;
    pending=true;
    requestAnimationFrame(()=>{pending=false;refresh();});
  }
  refresh();
  new MutationObserver(records=>{
    if(records.some(r=>r.type==='attributes'||[...r.addedNodes].some(n=>n.nodeType===1)))schedule();
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
  document.addEventListener('change',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  window.addEventListener('pageshow',schedule);
  window.addEventListener('focus',schedule);
  setInterval(refresh,60000);
})();
